export default "immagini/openair-benchmark-logo.svg"